"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRange = parseRange;
exports.isRangeTextValid = void 0;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MIN_IDX = 1;
var MAX_IDX = 3;
var INCREMENT_IDX = 5;
var RANGE_STRING_REGEX = /^([0-9.]+)(-([0-9.]*|infinity)|[+])?(#([0-9.]+))?$/i;
var INFINITY = 'INFINITY';

var isRangeTextValid = function isRangeTextValid(rangeText) {
  var trimmedRangeText = rangeText.trim();
  return trimmedRangeText.length !== 0 && Boolean(trimmedRangeText.match(RANGE_STRING_REGEX));
};

exports.isRangeTextValid = isRangeTextValid;

function parseRange(rangeText) {
  var trimmedRangeText = rangeText.trim();
  var match = trimmedRangeText.match(RANGE_STRING_REGEX);

  if (match) {
    var range = {
      minimum: match[MIN_IDX]
    };

    if (!(0, _isNil["default"])(match[MAX_IDX]) && match[MAX_IDX] !== '') {
      if (match[MAX_IDX].toUpperCase() !== INFINITY) {
        range.maximum = match[MAX_IDX];
      }
    } else if ((0, _isNil["default"])(match[MAX_IDX]) && (0, _isNil["default"])(match[INCREMENT_IDX])) {
      range.maximum = range.minimum;
    }

    if (!(0, _isNil["default"])(match[INCREMENT_IDX]) && match[INCREMENT_IDX] !== '') {
      range.increment = match[INCREMENT_IDX];
    }

    return range;
  }

  return null;
}